module.exports = __webpack_public_path__ + "static/media/Polygon-red.d31c8ded.svg";